import { Component, Input, EventEmitter, Output } from '@angular/core';

import { AngularMenuItem } from '../../models';

@Component({
    moduleId: module.id,
    selector: 'angular-breadcrumb',
    templateUrl: 'angular-breadcrumb.html'
})
export class AngularBreadcrumbComponent {    
    @Input() breadcrumbItemList: AngularMenuItem[] = new Array<AngularMenuItem>();
    @Input() homePage: string;

    @Output() onBreadcrumbItemClick = new EventEmitter();    

    doAction(menuItem = new AngularMenuItem) {       
        this.onBreadcrumbItemClick.emit(menuItem);
    }

    goHome(action: string) {
        let menuItem = new AngularMenuItem();
        menuItem.action = action;
        menuItem.funzione = "Home";
        this.onBreadcrumbItemClick.emit(menuItem);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/breadcrumb/angular-breadcrumb.component.ts